import React from "react";
import Autosuggest from 'react-autosuggest';


 class CustomSearch extends React.Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: []
    };    
  }
   getSuggestions = (value) => {
   
    const escapedValue =  (value.trim()).replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
    
    if (escapedValue === '') {
  
      return [];
    }
  
    //const regex = new RegExp('^' + escapedValue, 'i');
  
   // return this.props.values.filter(value => regex.test(value.name));
    return this.props.values.filter(value => (value.name).toLowerCase().search(
      escapedValue.toLowerCase()) !== -1
      )
        
  };
  
   getSuggestionValue = (suggestion) => {
   
    return suggestion.name;
  }
  
   renderSuggestion = (suggestion) => {
    
    
      return (
        <span>{suggestion.name}</span>
      );
    
   
  }

  onChange = (event, { newValue, method }) => {

    this.setState({
      value: newValue
    },()=>{
      if(this.state.value ===""){
        this.props.practiceId(0)
      }
    });
  };
  
  onSuggestionsFetchRequested = ({ value }) => {
    
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  
  };

  onSuggestionsClearRequested = () => {
   
    this.setState({
      suggestions: []
    });
 
  };

  onNicknameSuggestionSelected = (event, { suggestion }) => {
   
        this.props.practiceId(suggestion.id)
 
         
  };

  render() {
     const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: this.props.placeholder,
      value,
      onChange: this.onChange
    };
    
    return (
      <Autosuggest 
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onNicknameSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps} />
    );
  }
}

 
export default CustomSearch